<template>
  <div>
    <template v-if="programs.length">
      <b-row>
        <b-col xs="12">
          <h2 class="text-left mt-3 mb-5 font-weight-normal ">Aktuális programok</h2>
        </b-col>
      </b-row>
      <b-row class="mb-4" :v-if="!error">
        <b-card-group style="width: 100%;">
          <b-col class="text-center px-lg-0" sm="12" md="12" lg="12" xl="12">
            <carousel
              :per-page="2"
              :mouse-drag="true"
              :perPageCustom="responsiveCarouselSetting"
              :navigationEnabled="false"
              :autoplay="true"
              :loop="true"
              :autoplayTimeout="5000"
              paginationActiveColor="#3ba7de"
              paginationColor="#C4C4C4"
              :paginationSize="20"
            >
              <slide v-for="(p, index) in programs" :key="index" data-name="" @slideclick="navigateTo(p)">
                <b-card
                  tag="article"
                  class="mb-2"
                  v-bind:class="index % 3 === 0 ? 'green' : index % 2 === 0 ? 'blue' : 'red'"
                >
                  <div class="badge" v-if="p.status" v-bind:class="'badge-' + getStatusColor(p.status)">
                    {{ getReadableStatus(p.status) }}
                  </div>
                  <b-card-title> {{ p.name }} </b-card-title>
                  <b-card-text class="text-left mt-3" v-if="p.code">
                    {{ p.code }}
                  </b-card-text>
                </b-card>
              </slide>
            </carousel>
          </b-col>
        </b-card-group>
      </b-row>
    </template>
  </div>
</template>

<script>
import openLinkNewTab from '../mixins/openLinkNewTab'
import { Carousel, Slide } from 'vue-carousel'
import { listPrograms } from '../api/program'
import { PROGRAM_STATUS, getReadableProgramStatus } from '../views/Program/models/programStatus'
export default {
  mixins: [openLinkNewTab],
  name: 'Programs',
  components: {
    Carousel,
    Slide
  },
  created: async function() {
    try {
      const programs = await listPrograms()
      this.programs = programs
    } catch (e) {
      this.error = true
    }
  },
  methods: {
    navigateTo: function(item) {
      debugger
      if (item.openLinkInBlank) {
        this.openLinkNewTab(item.link)
      } else {
        window.location.href = item.link
      }
    },
    getReadableStatus: function(status) {
      return getReadableProgramStatus(status)
    },
    getStatusColor: function(status) {
      switch (status) {
        case PROGRAM_STATUS.REGISTRATION_OPEN:
          return 'green'
        case PROGRAM_STATUS.REGISTRATION_CLOSED:
          return 'red'
        case PROGRAM_STATUS.PREQUALIFICATION_CLOSED:
          return 'red'
        case PROGRAM_STATUS.PREQUALIFICATION_OPEN:
          return 'green'
      }
    }
  },
  data() {
    return {
      responsiveCarouselSetting: [
        [320, 1],
        [991, 2],
        [1299, 3]
      ],
      error: false,
      programs: []
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
}

a:hover {
  text-decoration: none;
}
.card:hover {
  cursor: pointer;
  transition: 0.5s;
  filter: drop-shadow(0px 4px 12px #2d3436);
}
.card {
  max-width: 95% !important;
  border: 0;
  background: #3ba7de;
  position: relative;
  border-radius: 7px;
  min-height: 365px;
  margin: 0 auto;
  padding-left: 25px;
  padding-right: 25px;
}
.card-body {
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  flex-direction: column;
}

.card-title {
  font-size: 32px;
  text-align: left !important;
  font-weight: bold;
}

.card-text {
  position: absolute;
  bottom: 2rem;
}

::v-deep .VueCarousel-dot:focus,
::v-deep .VueCarousel-dot:active {
  outline: 0px !important;
}

.card:before {
  content: ' ';
  display: block;
  position: absolute;
  left: auto;
  right: auto;
  width: 100%;
  height: 100%;
  z-index: 0;
  opacity: 0.7;
  background-image: url('../assets/img/logo/vekonyvali_hollow_outline.svg');
  background-repeat: no-repeat;
  background-size: contain;
  background-position: center;
  width: 60%;
  margin-left: auto;
  margin-right: auto;
  left: 0;
  right: 0;
  text-align: center;
}

.card.red:before {
  -webkit-transform: rotate(90deg);
  -moz-transform: rotate(90deg);
  -ms-transform: rotate(90deg);
  -o-transform: rotate(90deg);
  transform: rotate(90deg);
}

.card.blue:before {
  -webkit-transform: rotate(-90deg);
  -moz-transform: rotate(-90deg);
  -ms-transform: rotate(-90deg);
  -o-transform: rotate(-90deg);
  transform: rotate(-90deg);
}

.card.green {
  background-color: var(--color-green) !important;
}

.card.red {
  background-color: var(--color-red) !important;
}

.card.blue {
  background-color: var(--color-blue) !important;
}

.card-body {
  padding: 0.25rem !important;
  padding-bottom: 1.25rem !important;
  padding-top: 1.25rem !important;
  text-align: center;
}

@media (max-width: 993px) {
  .card {
    max-width: 100% !important;
  }
}

.card-text,
.card-title {
  color: white !important;
}

svg {
  width: 60px;
  height: 60px;
}

.svg-border {
  border: 3px solid white;
  padding: 20px;
  border-radius: 50%;
  width: auto;
  display: inline-table;
  margin-top: -5px;
}

.badge {
  position: absolute;
  width: 60%;
  height: 50px;
  background: var(--color-lightblue);
  left: 0;
  top: 0;
  border-bottom-right-radius: 100px;
  border-top-left-radius: 7px;
  padding-top: 15px;
  padding-right: 0;
  padding-left: 0;
  border-width: 0px;
  border-style: solid;
  font-size: 16px;
}

.badge.badge-green {
  border-color: #00903c;
  color: #00903c;
}

.badge.badge-red {
  border-color: #ba3b46;
  color: #ba3b46;
}

.badge .badge-text {
  margin-top: 6px;
  margin-left: -8px;
}
</style>
